//Paquetes NPM de GYF. 
import { Engine1Proxy, RestApiProxy, RabbitListener, SagasProxy, ConciergeProxy } from 'com-gyf-webcore-servicehub';
import { LogHelper } from 'com-gyf-webcore-loghelper';
import TransaccionManager from '../../../Common/Managers/TransaccionManager';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

export const GET_AUTORIZACIONES_RECHAZADAS = "GET_AUTORIZACIONES_RECHAZADAS";
export const GET_AUTORIZACIONES_RECHAZADAS_BUSQUEDA = "GET_AUTORIZACIONES_RECHAZADAS_BUSQUEDA";
export const ACTUALIZAR_AUTORIZACIONES_RECHAZADAS = "ACTUALIZAR_AUTORIZACIONES_RECHAZADAS";
export const LOADING_AUTORIZACIONES = "LOADING_AUTORIZACIONES";
export const ACTUALIZA_FECHA_AUTORIZACIONES = "ACTUALIZA_FECHA_AUTORIZACIONES";
export const ACTUALIZAR_AUTORIZACIONES_RECHAZADAS_BUSQUEDA = "ACTUALIZAR_AUTORIZACIONES_RECHAZADAS_BUSQUEDA";
export const ERROR_FOMARTO_FECHA_AUTORIZACIONES = "ERROR_FOMARTO_FECHA_AUTORIZACIONES";
export const ERROR_FECHA_POSTERIOR_AUTORIZACIONES = "ERROR_FECHA_POSTERIOR_AUTORIZACIONES";
export const ERROR_FECHA_AUTORIZACIONES = "ERROR_FECHA_AUTORIZACIONES";
export const AUTORIZACIONES_RANGO_DIAS = "AUTORIZACIONES_RANGO_DIAS";
export const OCULTAR_MODAL_AUTORIZACIONES = "OCULTAR_MODAL_AUTORIZACIONES";
export const MOSTRAR_CALENDARIOS_AUTORIZACIONES = "MOSTRAR_CALENDARIOS_AUTORIZACIONES";
export const REINICIAR_FECHAS_AUTRIZACIONES = "REINICIAR_FECHAS_AUTRIZACIONES";
export const MOSTRAR_DATOS_AUTORIZACIONES = "MOSTRAR_DATOS_AUTORIZACIONES";
export const OCULTAR_DATOS_AUTORIZACIONES = "OCULTAR_DATOS_AUTORIZACIONES";

let _dispatch,ctaTarjetaId;

export function getScreenDataAutorizaciones(cuentaTarjetaId) {
    LogHelper.In(getScreenDataAutorizaciones.name, cuentaTarjetaId);
    ctaTarjetaId = cuentaTarjetaId;

    return (dispatch, getState) => {
        _dispatch = dispatch;
        let state = getState();        

        _dispatch({ type: LOADING_AUTORIZACIONES, valor: true });

        let fechaHastaAux = new Date();
        let fechaDesdeAux = new Date();
        let mesActual = fechaHastaAux.getMonth() + 1;
    
        var newDate = new Date(fechaDesdeAux.setMonth(fechaDesdeAux.getMonth() - 3))
    
        let fechaHasta = fechaHastaAux.getFullYear() + "-" + (mesActual > 9 ? mesActual : ('0' + mesActual)) + "-" + fechaHastaAux.getDate();
        let fechaDesde = newDate.getFullYear() + "-" + (newDate.getMonth() + 1 > 9 ? newDate.getMonth() + 1 : ('0' + (newDate.getMonth() + 1))) + "-" + (newDate.getDate());
        
        let paramAutorizaciones = {
            'CuentaTarjetaId': ctaTarjetaId,
            'FechaDesde': fechaDesde,
            'FechaHasta': fechaHasta
        }
        
        Engine1Proxy.AddDataSourcesRequests(paramAutorizaciones, 'GET_AUTORIZACIONES_RECHAZADAS', 'Get', 'Tarjetas', 'PARAMETRIA', null, 'User', true, 'AutorizacionesRechazadas');
        Engine1Proxy.Execute((data) => _callbackgetScreenDataAutorizaciones(data,false), null, null, "CONSULTASOCIOS");

    }
}

export function actualizarAutorizacionesParaMostrar() {

    return (dispatch, getState) => {
        LogHelper.In(actualizarAutorizacionesParaMostrar.name);

        _dispatch = dispatch;        
        let state = getState().DatosCuenta.AutorizacionesRechazadas;

        if(state.BusquedaAutorizaciones)
            _dispatch({ type: ACTUALIZAR_AUTORIZACIONES_RECHAZADAS_BUSQUEDA });
        else
            _dispatch({ type: ACTUALIZAR_AUTORIZACIONES_RECHAZADAS });
    }
}

export function FormatoFechaDesde(fecha) {
    LogHelper.In(FormatoFechaDesde.name, fecha);

    return (dispatch, getState) => {
        if (validarFechaPosterior(fecha))
            dispatch({ type: ERROR_FECHA_POSTERIOR_AUTORIZACIONES, fechaTipo: "FechaDesdePosteriorAutorizaciones", mensajeTipo: "msjErrorCalendarioDesde", valor: true });
        else if (fecha == "Fecha inválida") {
            dispatch({ type: ERROR_FOMARTO_FECHA_AUTORIZACIONES, fechaTipo: "errorFechaDesdeAutorizaciones", mensajeTipo: "msjErrorCalendarioDesde", valor: true });
        } else {
            dispatch({ type: ERROR_FOMARTO_FECHA_AUTORIZACIONES, fechaTipo: "errorFechaDesdeAutorizaciones", valor: false });
            dispatch({ type: ERROR_FECHA_POSTERIOR_AUTORIZACIONES, fechaTipo: "FechaDesdePosteriorAutorizaciones", valor: false });
            dispatch({ type: ACTUALIZA_FECHA_AUTORIZACIONES, fechaTipo: "fechaDesde", fechaFormato:"formatoFechaDesdeAutorizaciones",valor: fecha });
        }
    }
}

export function FormatoFechaHasta(fecha) {
    LogHelper.In(FormatoFechaHasta.name, fecha);

    return (dispatch, getState) => {
        if (validarFechaPosterior(fecha))
            dispatch({ type: ERROR_FECHA_POSTERIOR_AUTORIZACIONES, fechaTipo: "FechaHastaPosteriorAutorizaciones", mensajeTipo: "msjErrorCalendarioHasta", valor: true });
        else if (fecha == "Fecha inválida") {
            dispatch({ type: ERROR_FOMARTO_FECHA_AUTORIZACIONES, fechaTipo: "errorFechaHastaAutorizaciones", mensajeTipo: "msjErrorCalendarioHasta", valor: true });
        } else {
            dispatch({ type: ERROR_FOMARTO_FECHA_AUTORIZACIONES, fechaTipo: "errorFechaHastaAutorizaciones", valor: false });
            dispatch({ type: ERROR_FECHA_POSTERIOR_AUTORIZACIONES, fechaTipo: "FechaHastaPosteriorAutorizaciones", valor: false });
            dispatch({ type: ACTUALIZA_FECHA_AUTORIZACIONES, fechaTipo: "fechaHasta", fechaFormato:"formatoFechaHastaAutorizaciones", valor: fecha });
        }
    }
}

export function buscarAutorizaciones(fechaDesde, fechaHasta) {
    LogHelper.In(buscarAutorizaciones.name, fechaDesde, fechaHasta);

    return (dispatch, getState) => {
        let stateAutorizaciones = getState().DatosCuenta.AutorizacionesRechazadas;

        if (!stateAutorizaciones.errorFechaDesdeAutorizaciones && !stateAutorizaciones.errorFechaHastaAutorizaciones &&
            !stateAutorizaciones.FechaDesdePosteriorAutorizaciones && !stateAutorizaciones.FechaHastaPosteriorAutorizaciones) {

            if(!stateAutorizaciones.formatoFechaDesdeAutorizaciones || !stateAutorizaciones.formatoFechaHastaAutorizaciones ) {
                dispatch({ type: ERROR_FECHA_AUTORIZACIONES, mensaje: "Por favor seleccione un rango de fechas a consultar.", valor: true });
            }
            else if (validarFechasAutorizaciones(fechaDesde, fechaHasta)) {
                dispatch({ type: ERROR_FECHA_AUTORIZACIONES, mensaje: "La fecha final debe ser mayor o igual a la fecha inicial.", valor: true });
            } else if (validarRangoDeDias(fechaDesde, fechaHasta)) {
                dispatch({ type: AUTORIZACIONES_RANGO_DIAS, valor: true });
            }
            else {

                dispatch({ type: ERROR_FECHA_AUTORIZACIONES, valor: false });
                dispatch({ type: AUTORIZACIONES_RANGO_DIAS, valor: false });
                dispatch({ type: LOADING_AUTORIZACIONES, valor: true });

                let paramAutorizaciones = {
                    'CuentaTarjetaId': ctaTarjetaId,
                    'FechaDesde': fechaDesde.split("/")[2] +"-"+ fechaDesde.split("/")[1] +"-"+ fechaDesde.split("/")[0],
                    'FechaHasta': fechaHasta.split("/")[2] +"-"+ fechaHasta.split("/")[1] +"-"+ fechaHasta.split("/")[0]
                }
                
                Engine1Proxy.AddDataSourcesRequests(paramAutorizaciones, 'GET_AUTORIZACIONES_RECHAZADAS', 'Get', 'Tarjetas', 'PARAMETRIA', null, 'User', true, 'AutorizacionesRechazadas');
                Engine1Proxy.Execute((data) => _callbackgetScreenDataAutorizaciones(data,true), null, null, "CONSULTASOCIOS");
                
            }
        }
    }
}

export function ocultarModalAutorizaciones() {
    return (dispatch, getState) => {
        dispatch({ type: OCULTAR_MODAL_AUTORIZACIONES });
    }
}

export function limpiarAutorizaciones(){
    return (dispatch, getState) => {
        dispatch({ type: LOADING_AUTORIZACIONES, valor: true });
        dispatch({ type: MOSTRAR_CALENDARIOS_AUTORIZACIONES, valor: false });
        dispatch({ type: REINICIAR_FECHAS_AUTRIZACIONES });    
    }
}

export function mostrarCalendariosAutorizaciones(){
    return (dispatch, getState) => {
        dispatch({ type: MOSTRAR_CALENDARIOS_AUTORIZACIONES, valor: true });
        dispatch({ type: LOADING_AUTORIZACIONES, valor: false }); 
    }
}

export function datosAutorizacion(mostrarDatos,index){
    return (dispatch, getState) => {
        if(mostrarDatos)
            dispatch({ type: MOSTRAR_DATOS_AUTORIZACIONES, mostrarDatos: mostrarDatos, index:index });
        else
            dispatch({ type: OCULTAR_DATOS_AUTORIZACIONES, mostrarDatos: mostrarDatos, index:index });
    }
}   

/**FUNCIONES AUXILIARES */


function _callbackgetScreenDataAutorizaciones(data,esBusqueda) {

    var Autorizaciones = {
        autorizacionesRechazadas: JSON.parse(data.AutorizacionesRechazadas).Recordset0.Rows
    }

    formatearDatos(Autorizaciones.autorizacionesRechazadas);

    if(esBusqueda)
        _dispatch({ type: GET_AUTORIZACIONES_RECHAZADAS_BUSQUEDA,  Autorizaciones });
    else
        _dispatch({ type: GET_AUTORIZACIONES_RECHAZADAS,  Autorizaciones });

    _dispatch({ type: LOADING_AUTORIZACIONES, valor: false });
}

function getMayorId(a, b) {
    const idA = a.id ? a.id : a.ID;
    const idB = b.id ? b.id : b.ID;

    let IDMayor = 0;
    if (idA > idB) {
        IDMayor = -1;
    } else if (idA < idB) {
        IDMayor = 1;
    }
    return IDMayor;
}

function formatearDatos(autorizaciones){
    autorizaciones.map((autorizaciones,index) => { 
        if(autorizaciones.FechaHora.includes("T")){
            let FechaAux = "", HoraAux = "";

            FechaAux = autorizaciones.FechaHora.split("T")[0];
            HoraAux = autorizaciones.FechaHora.split("T")[1].slice(0,5);
            autorizaciones.FechaHora = FechaAux + " " + HoraAux;
        }        
    })
}

function validarFechaPosterior(fecha) {
    let fechaAux = fecha.split("/");
    let fechaFinal;
    let fechaPosterior;

    let dia = fechaAux[0];
    let mes = fechaAux[1];
    let anio = fechaAux[2];
    fechaAux = mes + "/" + dia + "/" + anio;

    fechaFinal = new Date(fechaAux);

    if (fechaFinal > new Date())
        fechaPosterior = true;
    else
        fechaPosterior = false;

    return fechaPosterior;
}

function validarFechasAutorizaciones(fechaDesde, fechaHasta) {
    let fechaDesdeFinal, fechaHastaFinal, fechaDesdeAux, fechaHastaAux, fechaPosterior

    if (typeof fechaDesde == "object") {
        fechaDesdeAux = fechaDesdeAux.toLocaleDateString();
        fechaDesdeAux = fechaDesdeAux.length == 9 ? "0" + fechaDesdeAux : fechaDesdeAux;
    } else {
        fechaDesdeAux = fechaDesde;
    }

    if (typeof fechaHasta == "object") {
        fechaHastaAux = fechaHastaAux.toLocaleDateString();
        fechaHastaAux = fechaHastaAux.length == 9 ? "0" + fechaHastaAux : fechaHastaAux;
    } else {
        fechaHastaAux = fechaHasta;
    }

    fechaDesdeAux = fechaDesdeAux.split("/");
    let dia = fechaDesdeAux[0];
    let mes = fechaDesdeAux[1];
    let anio = fechaDesdeAux[2];
    fechaDesdeAux = mes + "/" + dia + "/" + anio;
    fechaDesdeFinal = new Date(fechaDesdeAux);

    fechaHastaAux = fechaHastaAux.split("/");
    dia = fechaHastaAux[0];
    mes = fechaHastaAux[1];
    anio = fechaHastaAux[2];
    fechaHastaAux = mes + "/" + dia + "/" + anio;
    fechaHastaFinal = new Date(fechaHastaAux);

    if (fechaDesdeFinal > fechaHastaFinal)
        fechaPosterior = true;
    else
        fechaPosterior = false;

    return fechaPosterior;
}

function validarRangoDeDias(fechaDesde, fechaHasta) {
    let fechaDesdeFinal, fechaHastaFinal, fechaDesdeAux, fechaHastaAux, diasDiferencia
    let moment = require('moment');

    if (typeof fechaDesde == "object") {
        fechaDesdeAux = fechaDesdeAux.toLocaleDateString();
        fechaDesdeAux = fechaDesdeAux.length == 9 ? "0" + fechaDesdeAux : fechaDesdeAux;
    } else {
        fechaDesdeAux = fechaDesde;
    }

    if (typeof fechaHasta == "object") {
        fechaHastaAux = fechaHastaAux.toLocaleDateString();
        fechaHastaAux = fechaHastaAux.length == 9 ? "0" + fechaHastaAux : fechaHastaAux;
    } else {
        fechaHastaAux = fechaHasta;
    }

    fechaDesdeAux = fechaDesdeAux.split("/");
    fechaDesdeFinal = moment(fechaDesdeAux[2] + "-" + fechaDesdeAux[1] + "-" + fechaDesdeAux[0]);

    fechaHastaAux = fechaHastaAux.split("/");
    fechaHastaFinal = moment(fechaHastaAux[2] + "-" + fechaHastaAux[1] + "-" + fechaHastaAux[0]);

    diasDiferencia = fechaHastaFinal.diff(fechaDesdeFinal, 'days');

    if (diasDiferencia > 90)
        return true
    else
        return false
}
